import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { list_type, option_type, record_type, string_type, int32_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Bindings_PlaneIdentifier_Id_Z3EBB1C36, Bindings_PlaneIdentifier_label_Z3EBB1C36, Bindings_IndexBounds_$reflection } from "../../RAWMap.Models/View/CenterlineMeasurement.js";
import { Visualization_UnifiedBranch_$reflection, Visualization_Centerline_$reflection } from "../../RAWMap.Models/Common.js";
import { empty } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { FormField_slider, FormField_labeledSlider, FormField_onChangeNumberDispatch } from "../../Common/Forms.js";
import { map, defaultArg } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { Split_View_makeHorizontalField } from "../MeasurementsView.js";
import { int32ToString } from "../../fable_modules/fable-library-js.4.19.3/Util.js";
import { CSSProp, HTMLAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.19.3/MapUtil.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.19.3/Seq.js";
import { Option } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";

export class SliderIndex extends Record {
    constructor(ActiveIndex, Direction, Bounds) {
        super();
        this.ActiveIndex = (ActiveIndex | 0);
        this.Direction = Direction;
        this.Bounds = Bounds;
    }
}

export function SliderIndex_$reflection() {
    return record_type("RAWMap.Client.Visualization.CenterlineMeasurement.Components.PlaneSlider.SliderIndex", [], SliderIndex, () => [["ActiveIndex", int32_type], ["Direction", string_type], ["Bounds", Bindings_IndexBounds_$reflection()]]);
}

export class SliderData extends Record {
    constructor(MaybeSelectedCenterline, MaybeSelectedBranch, CurrentIndices, PreviousIndices, PredefinedLabels) {
        super();
        this.MaybeSelectedCenterline = MaybeSelectedCenterline;
        this.MaybeSelectedBranch = MaybeSelectedBranch;
        this.CurrentIndices = CurrentIndices;
        this.PreviousIndices = PreviousIndices;
        this.PredefinedLabels = PredefinedLabels;
    }
}

export function SliderData_$reflection() {
    return record_type("RAWMap.Client.Visualization.CenterlineMeasurement.Components.PlaneSlider.SliderData", [], SliderData, () => [["MaybeSelectedCenterline", option_type(Visualization_Centerline_$reflection())], ["MaybeSelectedBranch", option_type(Visualization_UnifiedBranch_$reflection())], ["CurrentIndices", list_type(option_type(SliderIndex_$reflection()))], ["PreviousIndices", list_type(option_type(SliderIndex_$reflection()))], ["PredefinedLabels", list_type(string_type)]]);
}

export function SliderData_get_empty() {
    return new SliderData(undefined, undefined, empty(), empty(), empty());
}

export function mkLabeledPlaneSlider(indexChangedCallback, disabled, planeIdentifier, hideLabel, isSelected, sliderIndex) {
    const callback = FormField_onChangeNumberDispatch((maybeNumber) => {
        defaultArg(map(indexChangedCallback, maybeNumber), undefined);
    }, sliderIndex.ActiveIndex);
    const label = Bindings_PlaneIdentifier_label_Z3EBB1C36(planeIdentifier);
    return (!hideLabel ? ((contents) => Split_View_makeHorizontalField(label, true, contents)) : ((x) => x))(FormField_labeledSlider(sliderIndex.Bounds.firstIndex, sliderIndex.Bounds.lastIndex, 1, int32ToString(sliderIndex.ActiveIndex), [new HTMLAttr(99, [Bindings_PlaneIdentifier_Id_Z3EBB1C36(planeIdentifier)]), new HTMLAttr(64, ["horizontal-slider"]), ["style", keyValueList(toList(delay(() => append(isSelected ? singleton(new CSSProp(17, ["#bdffa49e"])) : empty_1(), delay(() => singleton(new CSSProp(124, [sliderIndex.Direction])))))), 1)]], [new Option(12, [""]), new Option(4, [disabled])], callback, "", []));
}

export function mkVerticalPlaneSlider(indexChangedCallback, disabled, planeIdentifier, sliderIndex) {
    const callback = FormField_onChangeNumberDispatch((maybeNumber) => {
        defaultArg(map(indexChangedCallback, maybeNumber), undefined);
    }, sliderIndex.ActiveIndex);
    return FormField_slider(sliderIndex.Bounds.firstIndex, sliderIndex.Bounds.lastIndex, 1, int32ToString(sliderIndex.ActiveIndex), [new HTMLAttr(99, [Bindings_PlaneIdentifier_Id_Z3EBB1C36(planeIdentifier)]), new HTMLAttr(64, ["vertical-slider__input"])], [new Option(4, [disabled])], callback);
}

